import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetailPage from './pages/ServiceDetailPage';
import TeamMemberDetailPage from './pages/TeamMemberDetailPage';
import Promo from './pages/Promo';
import Cases from './pages/Cases';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Booking from './pages/Booking';
import BookFormPage from './pages/BookForm';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import AfterHoursServices from './pages/AfterHoursServices';
import AsianSkinTreatment from './pages/AsianSkinTreatment';
import UltheraRichmondHill from './pages/UltheraRichmondHill';
import FAQ from './pages/FAQ';
import BookingSuccessPage from './pages/BookingSuccessPage';
import { LangProvider } from './context/LangContext';

function App() {
  return (
    <LangProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/team/:id" element={<TeamMemberDetailPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/promo" element={<Promo />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/book-form" element={<BookFormPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/thank-you" element={<BookingSuccessPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/after-hours-services" element={<AfterHoursServices />} />
            <Route path="/asian-skin-treatment" element={<AsianSkinTreatment />} />
            <Route path="/ulthera-richmond-hill" element={<UltheraRichmondHill />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </Layout>
      </Router>
    </LangProvider>
  );
}

export default App;
